import { render, staticRenderFns } from "./AccountRoot.vue?vue&type=template&id=031543eb&scoped=true&"
import script from "./AccountRoot.vue?vue&type=script&lang=ts&"
export * from "./AccountRoot.vue?vue&type=script&lang=ts&"
import style0 from "./AccountRoot.vue?vue&type=style&index=0&id=031543eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031543eb",
  null
  
)

export default component.exports